define('taoQtiItem/qtiItem/core/choices/SimpleChoice',['taoQtiItem/qtiItem/core/choices/ContainerChoice'], function(QtiContainerChoice){

    var QtiSimpleChoice = QtiContainerChoice.extend({
        qtiClass : 'simpleChoice'
    });

    return QtiSimpleChoice;

});



